<template>
    <v-container fluid class ="ma-0 pa-0">
      <v-layout class='pa-0'>
        <v-flex xs12 sm12 md12 lg12>
            <v-card v-for=" data in dat" :key="data.id" class="mb-5">
                <v-toolbar card :color="cr.colorName"  prominent>
                  <v-menu bottom fixed offset-y nudge-top='5'
                  max-width="500px" open-on-hover>
                 <v-btn slot="activator" icon>
                   <v-icon color="white" dark>info</v-icon></v-btn>
                   <v-list  >
                        <v-subheader>Display Case Information</v-subheader>
                        <v-subheader class=" text-truncate caption">{{data.portal_name}}</v-subheader>
                         <v-list-tile>
                         <v-list-tile-content>
                           <v-list-tile-title class="body-1 text-trucate"><span>Display Code:</span> {{data.code}}</v-list-tile-title>
                        </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                         <v-list-tile-content>
                           <v-list-tile-title class="body-1 text-trucate"><span>Display Type:</span> {{data.displayType}}</v-list-tile-title>
                        </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                         <v-list-tile-content>
                           <v-list-tile-title class="body-1 text-trucate"><span>Size:</span> {{data.size}}</v-list-tile-title>
                        </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                         <v-list-tile-content>
                           <v-list-tile-title class="body-1 text-trucate"><span>Location:</span> {{data.loc_descrp}}</v-list-tile-title>
                        </v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                         <v-list-tile-content>
                           <v-list-tile-title class="body-1 text-trucate"><span>Status:</span> {{data.status}}</v-list-tile-title>
                        </v-list-tile-content>
                        </v-list-tile>
                   </v-list>
                  </v-menu>
                  <v-toolbar-title class="body-1 white--text sub">Case Code: {{data.code}}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-tooltip top>
                    <v-btn icon :color="cr.colorName" class="white--text" slot="activator" @click.stop="issuesInfo(data.code, data.id)"><v-icon>fas fa-flag</v-icon></v-btn>
                    <span>Report an Issue</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <v-btn icon :color="cr.colorName" class="white--text" slot="activator" @click.stop="editDisplayInfo(data)"><v-icon>edit</v-icon></v-btn>
                    <span>Edit Display</span>
                  </v-tooltip>

                  <v-tooltip top>
                    <v-btn icon :color="cr.colorName" class="white--text" slot="activator" @click.stop="addInfo(data)">
                      <v-icon>add_circle</v-icon></v-btn>
                      <span>Add Display Graphic</span>
                  </v-tooltip>
                </v-toolbar>
                <v-container fluid class='pt-4 px-0'>
                  <v-card-text class='pa-0'>
                    <v-layout row>
                      <v-flex xs12 sm12 md12 lg 12>
                        <v-data-table light v-bind:headers="heads" :items="arr(data.displayId)" hide-actions class="pa-0" :expand="expand" :pagination.sync="pagination">
                          <template slot="items" scope="props" >
                            <tr @click="showNotes(props)">
                            <td class="text-xs-left pt-2">{{props.item.title}}</td>
                            <td class="text-xs-left pt-2">{{props.item.jobNum}}</td>
                            <td class="text-xs-left pt-2">{{props.item.status}}
                              <template v-if="props.item.status === 'Pending'">
                                <v-icon small class="pl-1" color="red"> fas fa-exclamation-triangle </v-icon>
                              </template>
                            </td>
                            <td class="text-xs-left pt-2">{{props.item.date}}</td>
                            <td class="text-xs-left pt-2">{{props.item.postby}}</td>
                            <td class="text-xs-left pt-2">{{props.item.install_date}}</td>
                            <td class="text-xs-left pt-2">{{props.item.qc_date}}</td>
                            <td>
                              <v-tooltip top>
                                <v-btn slot="activator" @click="changeStatus('ins')" icon fab small><v-icon small>fas fa-check-square</v-icon></v-btn>
                                <span>Installed</span>
                              </v-tooltip>
                              <template v-if="currentUser.id === 17 || currentUser.id === 1 || currentUser.id === 6">
                              <v-tooltip top>
                                <v-btn slot="activator" @click="changeStatus('qc')" icon fab small><v-icon small>fas fa-user-check</v-icon></v-btn>
                                <span>QC verified</span>
                              </v-tooltip></template>
                               <v-tooltip top>
                                  <v-btn icon slot="activator" @click.native="editMapInfo(props.item, data)" :value="props.item.serialCode">
                                    <v-icon small>fas fa-edit</v-icon></v-btn>
                                    <span>Edit Information</span>
                               </v-tooltip>
                              </td>
                              </tr>
                              <tr v-if="props.item.notes !== null">
                                <td :colspan="heads.length">
                                  <p><b>Notes&nbsp;for {{props.item.jobNum}}:&nbsp;</b>{{props.item.notes}}</p>
                                </td>
                              </tr>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-container>
            </v-card>
            <template v-if="issues.length !== 0">
               <v-card>
            <v-toolbar card :color="cr.colorName"  prominent>
              <v-toolbar-title class="body-1 white--text sub">
                 <v-icon small class="pl-1" color="red"> fas fa-exclamation-triangle </v-icon> Issues
              </v-toolbar-title>
            </v-toolbar>
            <v-container fluid class='pt-4 px-0'>
                  <v-card-text class='pa-0'>
                     <v-layout row>
                      <v-flex xs12 sm12 md12 lg 12>
                        <v-data-table :items="issues" light v-bind:headers="issueHeaders" hide-actions class="pa-0">
                          <template slot="items" scope="props" >
                            <td class="text-xs-left pt-2">{{props.item.issue_type}}</td>
                            <td class="text-xs-left pt-2">
                              <span v-for="i in getIssues(props.item.issue)" :key="i">
                                {{i}} <br>
                              </span>
                            </td>
                            <td class="text-xs-left pt-2">{{props.item.comments}}</td>
                            <td class="text-xs-left pt-2">{{props.item.ticket}}</td>
                            <td class="text-xs-left pt-2"><a :href="props.item.picture_url" target="_blank">{{props.item.picture_url}}</a></td>
                            <td class="text-xs-left pt-2">{{props.item.issue_date}}</td>
                            <td class="text-xs-left pt-2">{{props.item.resolved_date}}</td>
                            <td>
                                <v-tooltip top>
                                  <v-btn icon slot="activator" @click.native="editIssue(props.item)" :value="props.item.serialCode">
                                    <v-icon small>fas fa-edit</v-icon></v-btn>
                                    <span>Edit Issue</span>
                               </v-tooltip>
                                <v-tooltip top>
                                  <v-btn icon slot="activator" @click.native="resolvedIssue(props.item)" :value="props.item.serialCode">
                                    <v-icon small>fas fa-check</v-icon></v-btn>
                                    <span>Close Issue</span>
                               </v-tooltip>
                            </td>
                          </template>
                        </v-data-table>
                      </v-flex>
                     </v-layout>
                  </v-card-text>
            </v-container>
          </v-card>
            </template>
        </v-flex>
      </v-layout>
      <v-dialog v-model="openFormIssues" fullscreen scrollable transition="dialog-bottom-transition" :overlay="false" full-width>
        <v-card height="1500px">
          <v-toolbar style="flex: 0 0 auto;" :color='cr.colorName' class='white--text'>
          <v-btn icon @click.native="openFormIssues = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Report Form</v-toolbar-title>
          <v-spacer></v-spacer> 
          </v-toolbar>
          <formAddIssues :issues="openFormIssues" :cr="cr" :code="eCode" :displayId="eDisplayId" ></formAddIssues>
        </v-card>
      </v-dialog>
      <v-dialog v-model="openFormEditIssues" fullscreen scrollable transition="dialog-bottom-transition" :overlay="false" full-width>
        <v-card height="1500px">
          <v-toolbar style="flex: 0 0 auto;" :color='cr.colorName' class='white--text'>
          <v-btn icon @click.native="openFormEditIssues = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Report Form</v-toolbar-title>
          <v-spacer></v-spacer> 
          </v-toolbar>
          <formAddIssues :issues='false' :editForm="editIssueForm" :editIssueData="editIssueInfo" :cr="cr" :code="eCode" :displayId="eDisplayId" ></formAddIssues>
        </v-card>
      </v-dialog>
      <v-dialog v-model="openFormAddMap" fullscreen scrollable transition="dialog-bottom-transition" :overlay="false">
        <v-card style="height: 1361px">
             <v-toolbar style="flex: 0 0 auto;" :color='cr.colorName' class='white--text'>
          <v-btn icon @click.native="openFormAddMap = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Form</v-toolbar-title>
          <v-spacer></v-spacer>
          
        </v-toolbar>
            <formAddMap :add="openFormAddMap" :addData="addDat" :cr='cr'></formAddMap>
        </v-card>
    </v-dialog>
    <v-dialog v-model="editMap" fullscreen transition="dialog-bottom-transition" :overlay="false"
scrollable >
        <v-card style="height: 1361px;">
             <v-toolbar style="flex: 0 0 auto;" :color='cr.colorName' class='white--text'>
          <v-btn icon @click.native="editMap = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title class='white--text'>Form</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
         <formAddMap :edit="editData" :addData="addDat" :cr='cr'></formAddMap>
        </v-card>
    </v-dialog>
   <v-dialog v-model="openFormEditDisplay" 
             fullscreen transition="dialog-bottom-transition" :overlay="true" >
        <v-card>
             <v-toolbar style="flex: 0 0 auto;" :color='cr.colorName' class='white--text'>
          <v-btn icon @click.native="openFormEditDisplay = false" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>Form</v-toolbar-title>
          <v-spacer></v-spacer>
           
        </v-toolbar>
            <formAddDisplay :displayEdit="editDisplayData"
             :hideAdd="hideAdd" :id="valueId" :cr='cr' :readonly="true">
             </formAddDisplay>
        </v-card>
    </v-dialog>
     <v-dialog v-model="openDialog" max-width="500px" >
        <v-card>
          <v-card-title class="error white--text">
            <v-icon class="white--text pr-3">warning</v-icon><span>Something is wrong...</span>
            <v-icon class="white--text pl-2">fa-frown-o</v-icon>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
          <p>{{errorMsg}}</p>
          </v-card-text>
          <v-card-actions>
            <v-btn color="primary" flat @click.stop="openDialog=false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
</template>
<script>
import addmap from '../Forms/AddMap'
import addDisplay from '../Forms/AddDisplay'
import Issues from '../Forms/Issues'
import {bus} from '../../main'
import {mapGetters} from 'vuex'
export default {
  props: {
    dat: {
      type: Array
    },
    mapsData: {
      type: Array
    },
    railId: {
      type: String
    },
    cr: {
      type: Object
    },
    addSwitch: {
      type: Boolean
    },
    issues: {
      type: Array
    }
  },
  components: {
    formAddMap: addmap,
    formAddDisplay: addDisplay,
    formAddIssues: Issues
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      showDisplay: 'showDisplay'
    })
  },
  data () {
    return {
      pagination: {
        sortBy: 'jobNum',
        descending: true
      },
      noteMsg: {msg: '', jobnum: ''},
      openDialog: false,
      eCode: '',
      expand: false,
      eDisplayId: '',
      errorMsg: '',
      color: '',
      selected: [],
      show: false,
      hideAdd: false,
      editData: {},
      showForm: false,
      editDisplayData: {},
      editDisplay: {},
      editIssueInfo: {},
      addDat: {},
      valueId: '',
      editIssueForm: false,
      editMap: false,
      openFormIssues: false,
      openFormEditIssues: false,
      openFormAddMap: false,
      openFormEditDisplay: false,
      displayData: this.dat,
      heads: [
        {text: 'Title', value: 'title', align: 'left'},
        {text: 'Job Number', value: 'jobNum', align: 'left'},
        {text: 'Status', value: 'status', align: 'left'},
        {text: 'Last Update', value: 'date', align: 'left'},
        {text: 'Post By', value: 'postby', align: 'left'},
        {text: 'Installed on', value: 'install_date', align: 'left'},
        {text: 'QC on', value: 'qc_date', align: 'left'},
        {text: 'Actions', value: 'action', align: 'left'}
      ],
      issueHeaders: [
        {text: 'Issue Type', value: 'issue_type', align: 'left'},
        {text: 'Issues', value: 'issue', align: 'left'},
        {text: 'Comments', value: 'comments', align: 'left'},
        {text: 'Ticket#', value: 'ticket', align: 'left'},
        {text: 'Picture Url', value: 'picture_url', align: 'left'},
        {text: 'Issue Date', value: 'issue_date', align: 'left'},
        {text: 'Resolved Date', value: 'resolved_date', align: 'left'},
        {text: 'Actions', value: 'action', align: 'left'}
      ],
      items: ''
    }
  },
  watch: {
    dat () {
      this.dat = this.dat
      this.noteMsg.msg = ''
      this.noteMsg.jobnum = ''
    }
  },
  created () {
    var vm = this
    bus.$on('closeForm', (data, editInfo) => { // edit maps from search
      if (data.edit === true) {
        vm.editMap = false
      }
      if (data.add === true) {
        vm.openFormAddMap = false
      }
    })
    bus.$on('closeFormEditIssues', (data) => {
      vm.openFormEditIssues = data
    })
    bus.$on('closeFormIssues', (data) => {
      vm.openFormIssues = data
    })
    bus.$on('closeFormDisplayEdit', (data) => {
      vm.openFormEditDisplay = data
    })
    bus.$on('closeSaveFormEdit', (data) => {
      vm.openFormEditDisplay = data
    })
  },
  methods: {
    showNotes (item) {
      item.expanded = false
      this.expand = false
    },
    getIssues (item) {
      return [...item.data]
    },
    noteFooter (item) {
      if (item.status === 'Active' || item.status === 'Pending') {
        this.noteMsg.msg = item.notes
        this.noteMsg.jobnum = item.jobNum
      }
    },
    editIssue (data) {
      this.editIssueInfo = []
      this.openFormEditIssues = true
      this.editIssueForm = true
      this.editIssueInfo = data
      this.eCode = data.code
      this.eDisplayId = data.displayFk
    },
    resolvedIssue (data) {
      var url = 'mapsdata/issues/resolved/'
      this.$http.post(url, {
        code: data.code,
        id: data.id,
        date: new Date().toISOString()
      })
      .then(response => {
        bus.$emit('saveForm', data)
      })
    },
    issuesInfo (data, data2) {
      this.openFormIssues = true
      this.eCode = data
      this.eDisplayId = data2
    },
    findStatusPending (type) {
      if (type === 'qc') {
        return this.mapsData.filter(map => {
          return map.qc_date === null && map.status !== 'Expired'
        })
      }
      return this.mapsData.filter(map => {
        return map.status === 'Pending'
      })
    },
    changeStatus (type) {
      var data = this.findStatusPending(type)
      var obj = data[0]
      this.errorMsg = ''
      var url = 'mapsdata/map/updatestatus'
      if (data.length !== 0) {
        if (type === 'qc') {
          this.$http.post(url, {
            qc: true,
            installer: false,
            map_id: obj.id,
            code: obj.serialCode,
            date: new Date().toISOString()
          })
          .then(response => {
            bus.$emit('saveForm', data)
          })
        } else {
          this.$http.post(url, {
            qc: false,
            installer: true,
            map_id: obj.id,
            status: 'Active',
            isInstall: 'Yes',
            code: obj.serialCode,
            date: new Date().toISOString()
          })
          .then(response => {
            bus.$emit('saveForm', data)
          })
        }
      } else {
        this.openDialog = true
        this.errorMsg = 'You can only modify pending or active items.'
      }
    },
    checkNotes (id) {
      return this.countNotes(id)
    },
    editMapInfo (serialCode, displayDat) {
      this.editMap = true
      this.editData = serialCode
      this.addDat = displayDat
    },
    addInfo (info) {
      this.openFormAddMap = true
      this.addDat = info
      this.hideAdd = false
    },
    editDisplayInfo (dat) {
      this.openFormEditDisplay = true
      this.editDisplayData = dat
      this.noEdit = false
      this.hideAdd = true
    },
    closeDialog (flag) {
      this.editMap = flag
    },
    findTitle (id) {
      var vm = this
      let a = ''
      vm.data.forEach((d) => {
        if (d.id === id) {
          a = d.name
        }
      })
      return a
    },
    arr (id) {
      var vm = this
      var arr = []
      vm.mapsData.forEach(function (m) {
        if (m.displayFk === id) {
          arr.push(m)
        }
      })
      return arr
    },
    setvalueid (id) {
      this.openNotes = true
      this.valueId = id
    }
  }
}
</script>
<style scoped>
@media only screen and (max-width: 600px) {
  .sub{
    font-size: 10pt;
  } 
}
.list span{
  font-weight: bold;
}
h1 {
  font-size:14pt;
}
h4 {
  padding-top: 10px;
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/displays/Display.vue